import { useSelector } from 'react-redux';

import type { Lead } from '@kanda-libs/ks-frontend-services';

import useSearchQuery from 'hooks/useSearchQuery';
import { selectors } from 'store';

import { SEARCH_OPTIONS } from '../LeadTable/constants';

export interface LeadListPageHook {
  leads: Lead[];
  query: string;
  setQuery: (query: string) => void;
}

export default function useLeadListPage(): LeadListPageHook {
  const leads = useSelector(selectors.lead.getEntitiesAsArray);

  const { hits, query, setQuery } = useSearchQuery(
    leads,
    'leads',
    SEARCH_OPTIONS,
  );

  return {
    leads: hits.map(({ item }) => item),
    query,
    setQuery,
  };
}
